import React, {  useMemo, useState, useEffect } from 'react';
import Modal from 'react-modal';
import api from '../../service/api';
import EtapaFonteAusente from './EtapaFonteAusente';
import { HelpCircle, Ruler, Move3D  } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import { DayPicker } from "react-day-picker";
import { ptBR } from "date-fns/locale";
import "react-day-picker/dist/style.css";
import '../../css/PrescricaoTreinoAerobico.css';
import '../../css/style.css';
import { formatarNumero } from '../../utils/formato';


function PrescricaoTreinoAerobico({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
  // Navegação entre etapas
  const [etapa, setEtapa] = useState(1);
  const totalEtapas = 3;
  const porcentagemConclusao = (etapa / totalEtapas) * 100;

  const avancarEtapa = () => {
    if(etapa === 2 && tipoPrescricao === "Manual"){
      gerarTreinos();
    }
    setEtapa(etapa + 1);
    if(etapa === 1){
      // Utilizar futuramente para gerar a tabela de treino gerarTabela();
    }
  };

  const retrocederEtapa = () => {
    if (etapa > 1) {
      setEtapa(etapa - 1);
    }
  };

  // Popup de informações
  const [showInfo, setShowInfo] = useState(false);

  const [showInfoProcedimento, setShowInfoProcedimento] = useState("");

  // Modal para próxima etapa
  const [isNextModal, setIsNextModal] = useState(false);
  const openNextModal = () => {
    setIsNextModal(true);
  };
  const closeNextModal = () => {
    setIsNextModal(false);
  };

  // SALVAR E BUSCAR NO BD - LEVI
  // -------- Variaveis -------------
  const [tipoPrescricao, setTipoPrescricao] = useState("");

  // Manual ------------------
  const [treinos, setTreinos] = useState([]);
  const [nomeDoTreino, setNomeDoTreino] = useState("Plano semanal");
  const [numeroDeSecoes, setNumeroDeSecoes] = useState(3);
  const [geracaoModo, setGeracaoModo] = useState("secoes");
  const [selectedDays, setSelectedDays] = useState([]);

  // Automatico -------------------------
  const [metodo, setMetodo] = useState("padrao");
  const [objetivo, setObjetivo] = useState("Z1");
  const [intensidade, setIntensidade] = useState(0);
  const [FCRepouso, setFCRepouso] = useState("");
  const [FCReserva, setFCReserva] = useState("");

  // Opções de treino
  const [opcoes, setOpcoes] = useState(["Correr", "Pedalar", "Nadar"]);
  const [selecionados, setSelecionados] = useState([]);
  const [novaOpcao, setNovaOpcao] = useState("");

  const [demandaProposta, setDemandaProposta] = useState(0);
  const [nivel, setNivel] = useState("Iniciante");
  const [numSessoes, setNumSessoes] = useState(1);

  // Dados propagados: peso/idade vêm de evaluationData.antropometria;
  // vo2max vem de evaluationData.vo2.vo2.
  const [peso, setPeso] = useState('');
  const [idade, setIdade] = useState('');
  const [vo2max, setVo2max] = useState('');


  // Navega
  const selecionaPrescricao = (presc) => {

    if(presc === "Manual"){
      setTipoPrescricao("Manual")
      setEtapa(etapa + 1);
    }
    else{
      setTipoPrescricao("Automatico")
      setEtapa(etapa + 1);
    }
  }


  // Avalia se a pessoa entra com um valor fora do intervalo
  const [erro, setErro] = useState("");
  const handleBlur = () => {
    const val = Number(intensidade);

    if (isNaN(val)) {
      setErro("Digite um número válido.");
      return;
    }

    if (val < min || val > max) {
      setErro(`O valor deve estar entre ${min}% e ${max}%.`);
    } else {
      setErro(""); // válido → limpa erro
    }
  };

  // Troca e adição de novos exercicios no automatico
  const toggleOpcao = (opcao) => {
    setSelecionados((prev) =>
      prev.includes(opcao)
        ? prev.filter((o) => o !== opcao)
        : [...prev, opcao]
    );
  };

  const adicionarOpcao = () => {
    if (novaOpcao.trim() && !opcoes.includes(novaOpcao)) {
      setOpcoes([...opcoes, novaOpcao.trim()]);
      setNovaOpcao(""); // limpa input
    }
  };

    // ----- helpers -----
  const atualizarTreino = (index, campo, valor) => {
    setTreinos((prev) =>
      prev.map((treino, i) => (i === index ? { ...treino, [campo]: valor } : treino))
    );
  };

  const fmtTitulo = (dateObj) => {
    const dia = new Intl.DateTimeFormat("pt-BR", { weekday: "short" })
      .format(dateObj)
      .replace(".", "");
    const dataCurta = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(dateObj);
    const diaCap = dia.charAt(0).toUpperCase() + dia.slice(1);
    return `${diaCap} - ${dataCurta}`;
  };

  const gerarTreinos = () => {
    if (geracaoModo === "secoes") {
      const n = Math.max(0, Number(numeroDeSecoes || 0));
      const novasSecoes = Array.from({ length: n }, (_, i) => ({
        titulo: `Treino ${i + 1}`,
        descricao: "",
        dayoff: false, // só no modo seções
        tipo: "tempo",
        valor: "",
        zona: "zona1",
      }));
      setTreinos(novasSecoes);
      return;
    }

    // ---- modo "datas": cria a partir das datas clicadas (sem dayoff) ----
    // Defensivo: garante Date válido mesmo se vier string ISO do banco.
    const ordenadas = [...selectedDays]
      .map((d) => (d instanceof Date ? d : new Date(d)))
      .filter((d) => !Number.isNaN(d.getTime()))
      .sort((a, b) => a - b);
    const novasSecoes = ordenadas.map((d) => ({
      titulo: fmtTitulo(d),
      descricao: "",
      tipo: "tempo",
      valor: "",
      zona: "zona1",
      dataISO: d.toISOString().slice(0, 10),
    }));
    setTreinos(novasSecoes);
  };

  const temDatas = useMemo(() => selectedDays.length > 0, [selectedDays]);


  // 1. Seleciona FCR ou FCMAX
  
  // 2. Define a tabela de intensidade e troca a tabela de acordo com o metodo
  
  const intensidadesFCR = {
    Z1: { min: 50, max: 60 },
    Z2: { min: 60, max: 70 },
    Z3: { min: 70, max: 80 },
    Z4: { min: 80, max: 90 },
    Z5: { min: 90, max: 100 },
  };

  const intensidadesFCMax = {
    Z1: { min: 28, max: 42 },
    Z2: { min: 43, max: 56 },
    Z3: { min: 57, max: 70 },
    Z4: { min: 71, max: 83 },
    Z5: { min: 84, max: 100 },
  };

  // 2. escolhe tabela conforme método
  const intensidades = useMemo(() => {
    return metodo === "FCR" ? intensidadesFCR : intensidadesFCMax;
  }, [metodo]);

  // 3. pega min/max da zona conforme objetivo
  const { min, max } = useMemo(() => {
    return intensidades[objetivo] || { min: 0, max: 0 };
  }, [intensidades, objetivo]);

  // 3. calcula o FC Max com a fórmula de Tanaka
  const fcMax = 208 - 0.7 * idade;

  // ------------- Calculos com FCR --------------
  const calculaFCR = () => {
    const fcr = fcMax - Number(FCRepouso);
    setFCReserva(fcr);
  }

  // Cálculo da FC alvo pela fórmula de Karvonen
  const fcAlvoMin = Math.round(Number(FCRepouso) + (Number(FCReserva) * (min / 100)));
  const fcAlvoMax = Math.round(Number(FCRepouso) + (Number(FCReserva) * (max / 100)));

  // Calculos gerais

  // VO2 alvo
  const vo2res = vo2max - 3.5;
  const vo2Alvo = (intensidade / 100) * vo2res + 3.5;

  // METs
  const mets = vo2Alvo / 3.5;

  // Gasto energético
  const kcalMin = (mets * 3.5 * peso) / 200;

  // Demanda mínima sugerida (regra de 3)
  const demandaMinima = (300 * peso) / 70;

  // Duração em minutos
  const duracaoMinima = formatarNumero((demandaMinima / kcalMin), 0);
  const duracaoProposta = formatarNumero((demandaProposta / kcalMin), 0);


  // Para resultados (Tabelas)
  const tabelaIniciante = [
    { sessao: 1, perc: 100 },
    { sessao: 2, perc: 104 },
    { sessao: 3, perc: 108 },
    { sessao: 4, perc: 96 },
    { sessao: 5, perc: 112 },
    { sessao: 6, perc: 120 },
    { sessao: 7, perc: 128 },
    { sessao: 8, perc: 112 },
    { sessao: 9, perc: 96 },
    { sessao: 10, perc: 104 },
    { sessao: 11, perc: 112 },
    { sessao: 12, perc: 120 },

    { sessao: 13, perc: 112 },
    { sessao: 14, perc: 128 },
    { sessao: 15, perc: 132 },
    { sessao: 16, perc: 112 },
    { sessao: 17, perc: 96 },
    { sessao: 18, perc: 104 },
    { sessao: 19, perc: 112 },
    { sessao: 20, perc: 128 },
    { sessao: 21, perc: 132 },
    { sessao: 22, perc: 140 },
    { sessao: 23, perc: 148 },
    { sessao: 24, perc: 136 },
    { sessao: 25, perc: 128 },
    { sessao: 26, perc: 120 },
    { sessao: 27, perc: 112 },
    { sessao: 28, perc: 104 },

    { sessao: 29, perc: 120 },
    { sessao: 30, perc: 128 },
    { sessao: 31, perc: 132 },
    { sessao: 32, perc: 112 },
    { sessao: 33, perc: 96 },
    { sessao: 34, perc: 104 },
    { sessao: 35, perc: 112 },
    { sessao: 36, perc: 128 },
    { sessao: 37, perc: 132 },
    { sessao: 38, perc: 140 },
    { sessao: 39, perc: 148 },
    { sessao: 40, perc: 136 },
    { sessao: 41, perc: 128 },
    { sessao: 42, perc: 120 },
    { sessao: 43, perc: 112 },

    { sessao: 44, perc: 104 },
    { sessao: 45, perc: 120 },
    { sessao: 46, perc: 128 },
    { sessao: 47, perc: 132 },
    { sessao: 48, perc: 112 },
    { sessao: 49, perc: 96 },
    { sessao: 50, perc: 104 },
    { sessao: 51, perc: 112 },
    { sessao: 52, perc: 120 },
  ];

  const tabelaIntermediaria = [
    { sessao: 1, perc: 100 },
    { sessao: 2, perc: 108 },
    { sessao: 3, perc: 124 },
    { sessao: 4, perc: 100 },
    { sessao: 5, perc: 124 },
    { sessao: 6, perc: 128 },
    { sessao: 7, perc: 128 },
    { sessao: 8, perc: 96 },
    { sessao: 9, perc: 80 },
    { sessao: 10, perc: 64 },
    { sessao: 11, perc: 144 },
    { sessao: 12, perc: 128 },

    { sessao: 13, perc: 128 },
    { sessao: 14, perc: 144 },
    { sessao: 15, perc: 144 },
    { sessao: 16, perc: 96 },
    { sessao: 17, perc: 80 },
    { sessao: 18, perc: 64 },
    { sessao: 19, perc: 144 },
    { sessao: 20, perc: 128 },
    { sessao: 21, perc: 160 },
    { sessao: 22, perc: 168 },
    { sessao: 23, perc: 136 },
    { sessao: 24, perc: 128 },
    { sessao: 25, perc: 112 },
    { sessao: 26, perc: 96 },
    { sessao: 27, perc: 128 },

    { sessao: 28, perc: 144 },
    { sessao: 29, perc: 144 },
    { sessao: 30, perc: 96 },
    { sessao: 31, perc: 80 },
    { sessao: 32, perc: 64 },
    { sessao: 33, perc: 144 },
    { sessao: 34, perc: 128 },
    { sessao: 35, perc: 160 },
    { sessao: 36, perc: 168 },
    { sessao: 37, perc: 136 },
    { sessao: 38, perc: 128 },
    { sessao: 39, perc: 112 },
    { sessao: 40, perc: 96 },

    { sessao: 41, perc: 128 },
    { sessao: 42, perc: 144 },
    { sessao: 43, perc: 144 },
    { sessao: 44, perc: 96 },
    { sessao: 45, perc: 80 },
    { sessao: 46, perc: 128 },
    { sessao: 47, perc: 136 },
    { sessao: 48, perc: 152 },
    { sessao: 49, perc: 168 },
    { sessao: 50, perc: 136 },
    { sessao: 51, perc: 128 },
    { sessao: 52, perc: 112 },
  ];

  const tabelaAvancada = [
    { sessao: 1, perc: 100 },
    { sessao: 2, perc: 112 },
    { sessao: 3, perc: 124 },
    { sessao: 4, perc: 100 },
    { sessao: 5, perc: 136 },
    { sessao: 6, perc: 148 },
    { sessao: 7, perc: 152 },
    { sessao: 8, perc: 128 },
    { sessao: 9, perc: 104 },
    { sessao: 10, perc: 80 },
    { sessao: 11, perc: 176 },
    { sessao: 12, perc: 152 },

    { sessao: 13, perc: 176 },
    { sessao: 14, perc: 176 },
    { sessao: 15, perc: 128 },
    { sessao: 16, perc: 104 },
    { sessao: 17, perc: 80 },
    { sessao: 18, perc: 176 },
    { sessao: 19, perc: 152 },
    { sessao: 20, perc: 200 },
    { sessao: 21, perc: 212 },
    { sessao: 22, perc: 176 },
    { sessao: 23, perc: 152 },
    { sessao: 24, perc: 128 },
    { sessao: 25, perc: 104 },
    { sessao: 26, perc: 128 },
    { sessao: 27, perc: 176 },

    { sessao: 28, perc: 176 },
    { sessao: 29, perc: 128 },
    { sessao: 30, perc: 104 },
    { sessao: 31, perc: 80 },
    { sessao: 32, perc: 176 },
    { sessao: 33, perc: 152 },
    { sessao: 34, perc: 200 },
    { sessao: 35, perc: 212 },
    { sessao: 36, perc: 176 },
    { sessao: 37, perc: 152 },
    { sessao: 38, perc: 128 },
    { sessao: 39, perc: 104 },
    { sessao: 40, perc: 128 },

    { sessao: 41, perc: 176 },
    { sessao: 42, perc: 176 },
    { sessao: 43, perc: 132 },
    { sessao: 44, perc: 104 },
    { sessao: 45, perc: 176 },
    { sessao: 46, perc: 152 },
    { sessao: 47, perc: 188 },
    { sessao: 48, perc: 208 },
    { sessao: 49, perc: 176 },
    { sessao: 50, perc: 152 },
    { sessao: 51, perc: 128 },
    { sessao: 52, perc: 104 },
  ];

  const gerarTabela = () => {
    let tabelaNivel = [];

    if (nivel === "Iniciante") tabelaNivel = tabelaIniciante;
    else if(nivel === "Intermediário" )  tabelaNivel = tabelaIntermediaria;
    else tabelaNivel = tabelaAvancada;
    // depois você adiciona as outras (Básico, Estabilizador, Controle)

    const tabela = [];

    for (let i = 0; i < numSessoes; i++) {
      const sessao = i + 1;
      const perc = tabelaNivel[i % tabelaNivel.length].perc;
      const exercicio = selecionados[i % selecionados.length] || "-";
      const tempo = Math.round(duracaoProposta * (perc / 100));

      tabela.push({ sessao, exercicio, tempo });
    }

    return tabela;
  };


  useEffect(() => {
    setDemandaProposta(formatarNumero(demandaMinima, 0));
  }, [demandaMinima, objetivo]);
  
  // Altera o valor do grafico sempre que mudar
  const [data, setData] = useState([]);


  // Tabela de esforço

  // 0–100 → linha 1–15
  const activeRow = Math.min(
    15,
    Math.max(1, Math.round((intensidade / 100) * (15 - 1)) + 1)
  );

  // estilo da linha
  function rowStyle(id) {
    const isActive   = id === activeRow;
    const isNeighbor = id === activeRow - 1 || id === activeRow + 1;

    if (isActive) {
      // linha principal: mais forte e responsiva à intensidade
      const alpha = 0.25 + 0.55 * (intensidade / 100); // 0.25–0.80
      return { background: "#e73400" };
    }
    if (isNeighbor) {
      // vizinhas: um tom mais suave e fixo
      return { background: "#e73400ba" };
    }
    return {};
  }


  const td = {
    padding: "2px 12px",
    borderBottom: "1px solid #22262d",
  };
  const tdNum = {
    ...td,
    textAlign: "center",
    width: 80,
  };

  // sempre que mudar, atualiza os dados
  useEffect(() => {
    setData([
      {
        name: "Duração",
        Mínima: Number(duracaoMinima),
        Proposta: Number(duracaoProposta),
      },
    ]);
  }, [duracaoMinima, duracaoProposta]);

  // dispara toda vez que FCRepouso ou quando for alterado
  useEffect(() => {
    calculaFCR();
  }, [FCRepouso]);

  useEffect(() => {
    // Propaga dados da Antropometria e do VO2 (precedência: prescricaoAerobico próprio sobrescreve abaixo).
    if (evaluationData?.antropometria) {
      const a = evaluationData.antropometria;
      if (a.peso !== undefined) setPeso(a.peso);
      if (a.idade !== undefined) setIdade(a.idade);
    }
    if (evaluationData?.vo2?.vo2 !== undefined) {
      setVo2max(evaluationData.vo2.vo2);
    }

    if (evaluationData?.prescricaoAerobico) {
      const p = evaluationData.prescricaoAerobico;
      if (p.tipoPrescricao) setTipoPrescricao(p.tipoPrescricao);
      if (p.treinos) setTreinos(p.treinos);
      if (p.nomeDoTreino) setNomeDoTreino(p.nomeDoTreino);
      if (p.numeroDeSecoes) setNumeroDeSecoes(p.numeroDeSecoes);
      if (p.geracaoModo) setGeracaoModo(p.geracaoModo);
      // Datas voltam do banco como string ISO; reconverte para Date (descarta inválidas).
      if (p.selectedDays) {
        setSelectedDays(
          p.selectedDays
            .map((dia) => (dia instanceof Date ? dia : new Date(dia)))
            .filter((dia) => !Number.isNaN(dia.getTime()))
        );
      }
      if (p.metodo) setMetodo(p.metodo);
      if (p.objetivo) setObjetivo(p.objetivo);
      if (p.intensidade) setIntensidade(p.intensidade);
      if (p.FCRepouso) setFCRepouso(p.FCRepouso);
      if (p.FCReserva) setFCReserva(p.FCReserva);
      if (p.selecionados) setSelecionados(p.selecionados);
      if (p.demandaProposta) setDemandaProposta(p.demandaProposta);
      if (p.nivel) setNivel(p.nivel);
      if (p.numSessoes) setNumSessoes(p.numSessoes);
    }
  }, [evaluationData]);

  const handlePrescricaoAerobicoRegister = async () => {
    const payload = {
      prescricaoAerobico: {
        tipoPrescricao, treinos, nomeDoTreino, numeroDeSecoes,
        geracaoModo, selectedDays,
        metodo, objetivo, intensidade,
        FCRepouso, FCReserva,
        selecionados, demandaProposta, nivel, numSessoes
      },
      evaluationId
    };

    try {
      const response = await api.post(`/api/student/${aluno.id}/evaluation/prescricao-aerobico`, payload, { withCredentials: true });
      if (response.status === 200) {
        if (response.data.evaluationId && setEvaluationId) {
          if (!evaluationId) {
            if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
            aluno.avaliacoesRealizadas.push({
              id: response.data.evaluationId,
              data: new Date().toISOString()
            });
          }
          setEvaluationId(response.data.evaluationId);
        }
        if (updateEvaluationData) {
          updateEvaluationData({ prescricaoAerobico: payload.prescricaoAerobico });
        }
        openNextModal();
      }
    } catch (error) {
      console.error('Erro ao salvar Prescrição Aeróbico:', error);
    }
  };

  // Navegação provisória
  const toAvaliacaoNeuromuscular = () => {
    setActiveTab("AvaliacaoNeuromuscular");
  };

  // CAP-3: bloqueia se alguma das etapas-fonte (Antropometria, VO2) não foi preenchida.
  const antropometriaPresente = evaluationData?.antropometria?.peso !== undefined;
  const vo2Presente = evaluationData?.vo2?.vo2 !== undefined;
  if (!antropometriaPresente || !vo2Presente) {
    return (
      <EtapaFonteAusente
        etapaAtual="Prescrição Aeróbio"
        etapasFontes={[
          { nome: 'Antropometria', tabKey: 'Antropometria', presente: antropometriaPresente },
          { nome: 'VO2', tabKey: 'Vo2', presente: vo2Presente },
        ]}
        setActiveTab={setActiveTab}
      />
    );
  }

  return (
    <div className="avaliacao-container">
      <div className="avaliacao-content">
        {etapa === 1 && (
          <div className="questions-container">
            <div className="questions-left">
              <div className="standard-title">Prescrição de Treino Aeróbico</div>
              <div className="margin-left-5 composicao-title">Selecione o tipo de prescrição:</div>
              <div className="selecao-metodo-container">
                <button className="next-prev-button metodo-button metodo-unificado" type="button" onClick={() => selecionaPrescricao("Manual")}>
                  <Ruler className="icone-botao" />
                  Prescrição Manual
                </button>
                <button className="next-prev-button metodo-button metodo-unificado" type="button" onClick={() => selecionaPrescricao("Automatico")}>
                  <Move3D className="icone-botao" />
                  Prescrição Automatica
                </button>
              </div>
            </div>
          </div>
        )}
        {etapa === 2 && (
          <div>
            {tipoPrescricao === "Automatico" && (
              <div className="questions-container">
                <div className="questions-33">
                  <div className="question-item">
                    <div className="question-title">Prescrição de Treino Aeróbico</div>
                    <div className="form-treino">
                      <p>Selecione o Cálculo da Zona Alvo de treino:</p>
                      <select className="select-personalizado" value={metodo} onChange={(e) => setMetodo(e.target.value)}>
                        <option value="padrao">Selecione um parâmetro...</option>
                        <option value="FCR">Frequência Cardíaca de Reserva</option>
                        <option value="FCMAX">Frequência Cardíaca Máxima</option>
                      </select>

                      {metodo !== "padrao" && (
                        <div>
                        {metodo === "FCR" && (
                          <div className="extra-div margin-top-10">
                            <div className="container-entrada-intensidade">
                              <p>Frequencia Cardíaca de Repouso:</p>
                              <input
                                className="entrada-intensidade-demanda"
                                type="number"
                                name="FCRepouso"
                                placeholder={FCRepouso}
                                value={FCRepouso}
                                onChange={(e) => setFCRepouso(e.target.value)}
                              />
                              <p>bpm</p>
                            </div>
                          </div>
                        )}
                        <div className="extra-div margin-top-10">
                          <div>
                            <p>Selecione o objetivo do trabalho aeróbico:</p>
                            <select className="select-personalizado" value={objetivo} onChange={(e) => setObjetivo(e.target.value)}>
                              <option value="Z1">Z1 – Regenerativa</option>
                              <option value="Z2">Z2 – Lipolítica</option>
                              <option value="Z3">Z3 – Condicionamento</option>
                              <option value="Z4">Z4 – Limiar anaeróbio</option>
                              <option value="Z5">Z5 – Esforço máximo</option>
                            </select>

                            <div>
                              <p className="zona-selecionada">Intensidade da zona selecionada: <b>{min}% – {max}%</b></p>
                            </div>

                            <div className="container-entrada-intensidade">
                              <p>Intensidade proposta:</p>
                              <input
                                className="entrada-intensidade-demanda"
                                type="number"
                                name="intensidade"
                                min={min}
                                max={max}
                                placeholder={intensidade}
                                value={intensidade}
                                onChange={(e) => setIntensidade(e.target.value)}
                                onBlur={handleBlur}
                              />
                              <p>%</p>
                            </div>

                            {erro && <p style={{ color: "red" }}>{erro}</p>}

                            <div className="container-demandas">
                              <p>Demanda mínima sugerida: <b>{formatarNumero(demandaMinima, 0)} kcal</b></p>
                              <div className="container-entrada-intensidade">
                                <p>Demanda energética proposta:</p>
                                <input
                                  type="number"
                                  className="entrada-intensidade-demanda"
                                  value={demandaProposta}
                                  onChange={(e) => setDemandaProposta(Number(e.target.value))}
                                />
                                <p> kcal</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    </div>
                  </div>
                </div>
                <div className="questions-33">
                  <div className="question-item">
                    <div className="question-title">Resultados</div>
                    <div className="container-resultado-presc-aero">
                      <div className="container-resultado-presc-col-1">
                        <p>❤️</p>
                      </div>
                      <div className="container-resultado-presc-col-2">
                        {metodo === "FCMAX" && (<p>FC Max:</p>)}
                        {metodo === "FCR" && (<p>FC Alvo:</p>)}
                        <p>VO₂ de treino: </p>
                      </div>
                      <div className="container-resultado-presc-col-3">
                        {metodo === "FCMAX" && (<b>{formatarNumero(fcMax, 0)}bpm</b>)}
                        {metodo === "FCR" && (<b>{fcAlvoMin} - {fcAlvoMax}bpm</b>)}
                        <b>{formatarNumero(vo2Alvo, 2)}ml/kg/min</b> 
                      </div>
                    </div>
                    <div className="container-resultado-presc-aero">
                      <div className="container-resultado-presc-col-1">
                        <p>🔥</p>
                      </div>
                      <div className="container-resultado-presc-col-2">
                        <p>METs de treino: </p>
                        <p>Kcal/min: </p>
                      </div>
                      <div className="container-resultado-presc-col-3">
                        <b>{formatarNumero(mets, 2)}</b>
                        <b>{formatarNumero(kcalMin, 2)}</b>
                      </div>
                    </div>
                    <div className="container-resultado-presc-aero presc-aero-end">
                      <div>
                        <p>Duração mínima sugerida: <b className="resultado-duracao-sug">{duracaoMinima} min</b></p>
                        <p className='margin-top-15'>Duração proposta: <b className="resultado-duracao-prop">{duracaoProposta} min</b></p>
                      </div>
                      <ResponsiveContainer width="100%" height={130}>
                        <BarChart data={data} barGap={20}>
                          <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                          <XAxis dataKey="name" stroke="#ccc" />
                          <YAxis stroke="#ccc" />
                          <Bar dataKey="Mínima" fill="#27ae60" radius={[3, 3, 0, 0]} />
                          <Bar dataKey="Proposta" fill="#f94c1a" radius={[3, 3, 0, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
                <div className="questions-33">
                  <div className="question-item">
                    <div className="question-title">Percepção subjetiva de esforço</div>
                      <div className='pad-left-5'>
                        <table className="tabela-percepcao-subjetiva">
                          <thead>
                            <tr style={{ background: "#171a1f" }}>
                              <th style={{ padding: "8px 12px", textAlign: "left", borderBottom: "1px solid #2a2f36" }}>
                                Percepção subjetiva
                              </th>
                              <th style={{ padding: "8px 12px", borderBottom: "1px solid #2a2f36" }}>Borg</th>
                              <th style={{ padding: "8px 12px", borderBottom: "1px solid #2a2f36" }}>Adaptada</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style={rowStyle(1)}>
                              <td style={td}></td><td style={tdNum}>6</td><td style={tdNum}>1</td>
                            </tr>
                            <tr style={rowStyle(2)}>
                              <td style={td}>Muito, muito leve</td><td style={tdNum}>7</td><td style={tdNum}>1</td>
                            </tr>
                            <tr style={rowStyle(3)}>
                              <td style={td}></td><td style={tdNum}>8</td><td style={tdNum}>1</td>
                            </tr>
                            <tr style={rowStyle(4)}>
                              <td style={td}>Muito leve</td><td style={tdNum}>9</td><td style={tdNum}>2</td>
                            </tr>
                            <tr style={rowStyle(5)}>
                              <td style={td}></td><td style={tdNum}>10</td><td style={tdNum}>3</td>
                            </tr>
                            <tr style={rowStyle(6)}>
                              <td style={td}>Moderadamente leve</td><td style={tdNum}>11</td><td style={tdNum}>3</td>
                            </tr>
                            <tr style={rowStyle(7)}>
                              <td style={td}></td><td style={tdNum}>12</td><td style={tdNum}>4</td>
                            </tr>
                            <tr style={rowStyle(8)}>
                              <td style={td}>Um pouco pesado</td><td style={tdNum}>13</td><td style={tdNum}>5</td>
                            </tr>
                            <tr style={rowStyle(9)}>
                              <td style={td}></td><td style={tdNum}>14</td><td style={tdNum}>6</td>
                            </tr>
                            <tr style={rowStyle(10)}>
                              <td style={td}>Pesado</td><td style={tdNum}>15</td><td style={tdNum}>6</td>
                            </tr>
                            <tr style={rowStyle(11)}>
                              <td style={td}></td><td style={tdNum}>16</td><td style={tdNum}>7</td>
                            </tr>
                            <tr style={rowStyle(12)}>
                              <td style={td}>Muito pesado</td><td style={tdNum}>17</td><td style={tdNum}>8</td>
                            </tr>
                            <tr style={rowStyle(13)}>
                              <td style={td}></td><td style={tdNum}>18</td><td style={tdNum}>9</td>
                            </tr>
                            <tr style={rowStyle(14)}>
                              <td style={td}>Muito, muito pesado</td><td style={tdNum}>19</td><td style={tdNum}>10</td>
                            </tr>
                            <tr style={rowStyle(15)}>
                              <td style={td}></td><td style={tdNum}>20</td><td style={tdNum}>10</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
                </div>
              </div>
            )}
            {tipoPrescricao === "Manual" && (
              <div className="questions-container">
                <div className="questions-left">
                  <div className="question-item">
                    <div className="question-title">Prescrição de Treino Aeróbico</div>
                    <div className="form-treino">
                      <div className="campo">
                        <label>Nome do Treino: </label>
                        <input
                          className='answer-text'
                          type="text"
                          value={nomeDoTreino}
                          onChange={(e) => setNomeDoTreino(e.target.value)}
                        />
                      </div>
                      <fieldset className="campo margin-top-10">
                        <legend>Como deseja gerar?</legend>
                        <label className="opcao-geracao-treino">
                          <input
                            className='answer-radio'
                            type="radio"
                            name="modo"
                            value="secoes"
                            checked={geracaoModo === "secoes"}
                            onChange={() => setGeracaoModo("secoes")}
                          />
                          <div className='margin-left-5'>Número de seções</div>
                        </label>
                        <label style={{ marginLeft: 20 }} className="opcao-geracao-treino">
                          <input
                            className='answer-radio'
                            type="radio"
                            name="modo"
                            value="datas"
                            checked={geracaoModo === "datas"}
                            onChange={() => setGeracaoModo("datas")}
                          />
                          <div className='margin-left-5'>Por datas</div>
                        </label>
                      </fieldset>
                      {geracaoModo === "secoes" ? (
                        <div className="campo margin-top-15">
                          <label>Número de seções:</label>
                          <input
                            className='answer-text margin-left-5 width-50px'
                            type="number"
                            min={0}
                            value={numeroDeSecoes}
                            onChange={(e) => setNumeroDeSecoes(e.target.value)}
                          />
                        </div>
                        ) : (
                        <div className="campo margin-top-15">
                          <DayPicker
                            mode="multiple"
                            selected={selectedDays}
                            onSelect={setSelectedDays}
                            locale={ptBR}
                            showOutsideDays
                            weekStartsOn={1}
                            captionLayout="dropdown"
                          />
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {etapa === 3 && tipoPrescricao === "Manual" && (
          <div className="prescricao-treinos-content">
            <div className="question-title">{nomeDoTreino}</div>
            <div className="grade-de-caixas">
              {treinos.map((treino, index) => (
                <div key={index} className="caixa-treino">
                  <h2 className="titulo-treino">{treino.titulo}</h2>

                  {/* Descrição */}
                  <textarea
                    type="text-area"
                    name="descricao"
                    value={treino.descricao}
                    onChange={(e) => atualizarTreino(index, "descricao", e.target.value)}
                    placeholder="Descrição do treino"
                    className="entrada-descricao-treino"
                  />

                  {/* Dayoff apenas no modo 'secoes' */}
                  {geracaoModo === "secoes" && (
                    <label className="dayoff-treino" style={{ display: "flex", gap: 8, marginTop: 8 }}>
                      <input
                        type="checkbox"
                        checked={!!treino.dayoff}
                        onChange={(e) => atualizarTreino(index, "dayoff", e.target.checked)}
                      />
                      Dayoff
                    </label>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {etapa === 3 && tipoPrescricao === "Automatico" &&(
          <div className="questions-container">
            <div className="questions-left">
              <div className="question-title">Plano do treino</div>
                <div className="form-treino">
                  <fieldset className="caixa-selecao-exercicios-pta">
                    <legend>Selecione os exercicios:</legend>
                    <div className="opcoes-exercicios-pta">
                      {opcoes.map((opcao) => (
                        <label key={opcao}>
                          <input
                            className='answer-checkbox'
                            type="checkbox"
                            checked={selecionados.includes(opcao)}
                            onChange={() => toggleOpcao(opcao)}
                          />
                          <p>{opcao}</p>

                        </label>
                      ))}
                    </div>
                    <div className="entrada-novo-exercicio-pta">
                      <input
                        type="text"
                        value={novaOpcao}
                        onChange={(e) => setNovaOpcao(e.target.value)}
                        placeholder="Adicionar novo exercício"
                      />
                      <a className="next-prev-button" onClick={adicionarOpcao}>Adicionar</a>
                    </div>
                  </fieldset>
                  <fieldset>
                    <legend>Selecione o nivel:</legend>
                    <div className="opcoes-exercicios-pta">
                      <label>
                        <input
                          className='answer-radio'
                          type="radio"
                          name="nivel"
                          value="Iniciante"
                          checked={nivel === "Iniciante"}
                          onChange={(e) => setNivel(e.target.value)}
                        />
                        Iniciante
                      </label>

                      <label>
                        <input
                          className='answer-radio'
                          type="radio"
                          name="nivel"
                          value="Intermediário"
                          checked={nivel === "Intermediário"}
                          onChange={(e) => setNivel(e.target.value)}
                        />
                        Intermediário
                      </label>

                      <label>
                        <input
                          className='answer-radio'
                          type="radio"
                          name="nivel"
                          value="Avançado"
                          checked={nivel === "Avançado"}
                          onChange={(e) => setNivel(e.target.value)}
                        />
                        Avançado
                      </label>
                    </div>
                  </fieldset>
                  <fieldset  className="caixa-selecao-exercicios-pta">
                    <legend>Numero de secoes:</legend>
                    <input
                      className="entrada-intensidade-demanda"
                      type="number"
                      min="1"
                      value={numSessoes}
                      onChange={(e) => setNumSessoes(Number(e.target.value))}
                    />
                  </fieldset>
                </div>
            </div>
            <div className="questions-right">
              <div className="question-item">
                <div className="question-title">Plano de sessões</div>
                <div className='pad-left-5'>
                  <table className="tabela-percepcao-subjetiva">
                    <thead>
                      <tr style={{ background: "#171a1f" }}>
                        <th style={{ padding: "8px 12px", borderBottom: "1px solid #2a2f36" }}>Sessão</th>
                        <th style={{ padding: "8px 12px", textAlign: "left", borderBottom: "1px solid #2a2f36" }}>Exercício</th>
                        <th style={{ padding: "8px 12px", borderBottom: "1px solid #2a2f36" }}>Duração (min)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gerarTabela().map((s) => (
                        <tr key={s.sessao}>
                          <td style={tdNum}>{s.sessao}</td>
                          <td style={td}>{s.exercicio}</td>
                          <td style={tdNum}>{s.tempo}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          isOpen={isNextModal}
          onRequestClose={closeNextModal}
          contentLabel="Confirmacao"
          className="modal-next"
          overlayClassName="popup-overlay"
          >
            <p className="popupNext-h1">Prescrição de Treino Aeróbico finalizada!</p>
            <p className="popupNext-h2">Deseja ir para a Avaliação Neuromuscular?</p>
            <div className="sub-pagination-buttons">
              <button className="next-prev-button" type="button" onClick={toAvaliacaoNeuromuscular}>
                Sim
              </button>
              <button className="next-prev-button" type="button" onClick={closeNextModal}>
                Não
              </button>
            </div>
        </Modal>

        <div className="pagination-footer">
          <div className="sub-pagination-footer">
            <div className="sub-pagination-buttons">
              {etapa > 0 && (
                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                  Voltar
                </button>
              )}
              {etapa < totalEtapas ? (
                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                  Avançar
                </button>
              ) : (
              <button className="next-prev-button" type="button" onClick={handlePrescricaoAerobicoRegister}>Registrar</button>
              )}
            </div>
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
            </div>
          </div>
          <div className="info-box-container">
            <div>
              <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                <HelpCircle size={20} />
                Mais informações
              </div>
              {showInfo && (
                <div className="info-box-content">
                  <div>
                    <p className="">
                      A prescrição do treinamento aeróbico é o processo de planejamento individualizado das atividades cardiovasculares com base no nível de condicionamento, objetivos e necessidades de cada avaliado.
                      <br/><br/>
                      Por meio de variáveis como intensidade, volume, frequência, métodos de treino e zonas de esforço, é possível estruturar programas voltados para emagrecimento, melhora da saúde cardiovascular, aumento de performance ou desenvolvimento da resistência.
                      <br/><br/>
                      Uma prescrição bem elaborada promove maior segurança, eficiência e progressão dos resultados, permitindo que o treinamento seja ajustado de forma estratégica e personalizada.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}

export default PrescricaoTreinoAerobico;
